<template>
  <div class="pc_search-wrapper pxstrict">
    <!-- <h-head></h-head> -->
    <!-- 搜索框 -->
    <div class="search-input-wrapper pxstrict">
      <div @click="goto" class="back">
        <img src="../../assets/image/home/back-icon.png" alt="" />
      </div>
      <div class="input-wrapper">
        <i class="i-search"></i>
        <input
          ref="myInput"
          class="search-input"
          v-model="searchParams.keyWord"
          type="text"
          :placeholder="$t('PCSearch.index.646wgb1ni8k0')"
          @input="keywordChange"
        />
        <i class="i-clear" @click="clear" v-show="searchParams.keyWord"></i>
      </div>
    </div>
    <div class="search-history">
      <div class="search-history-title">
        <span>Historial de búsqueda</span>
        <img
          src="../../assets/PC/img/delete.png"
          alt=""
          class="delete-icon"
          @click="clearSearchHistory"
        />
      </div>
      <div class="search-history-list">
        <span v-for="(term, index) in searchHistory" :key="index" @click="goPage(term)">
          {{ term.name }}
        </span>
      </div>
    </div>
    <!-- 搜索列表 -->
    <div class="van-list-wrapper pxstrict" v-show="showSearchList">
      <van-list
        v-model="searchLoading"
        :finished="searchFinished"
        finished-text=""
        @load="onLoadSearch"
      >
        <div
          class="search-item"
          :key="`search-item-${item.productId}`"
          v-for="item in searchList"
          @click="goPage(item)"
        >
          <span class="name">{{ item.name }}</span>
        </div>
      </van-list>
      <!-- <div class="text-no" @click="goAddModel">
        <img src="../../assets/image/search/no-order.png" alt="">
      </div> -->
    </div>
    <!--文本为：抱歉，没有找到对应的机型，请搜索其他机型或联系客服添加该机型。-->
    <div class="search-list-blank pxstrict" v-if="showSearchBlank" @touchmove.prevent>
      <div class="text-no">
        <!-- <img src="../../assets/assets/PC/img/search-no@2x.png" alt=""> -->
        <img src="../../assets/PC/img/search-no@2x.png" alt="" />
        <span>Lo siento, el modelo no existe</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, List } from 'vant';
import hHead from '@/components/layout/head.vue';
import { searchPhoneModel } from '../../services/api/product';
import { Dialog } from 'vant';
export default {
  name: 'Search',
  data() {
    return {
      timer: null,
      searchParams: {
        keyWord: '',
        pageSize: 30,
        currentPage: 1
      },
      showDialog: true,
      searchList: [],
      searchLoading: false,
      searchFinished: false,
      loading: true,
      searchHistory: []
    };
  },
  mounted() {
    this.$refs.myInput.focus();
    this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
  },
  computed: {
    /**
     * 是否显示搜索列表
     */
    showSearchList() {
      return this.searchParams.keyWord && this.searchList.length !== 0;
    },
    /**
     * 是否显示空搜索提示
     */
    showSearchBlank() {
      return this.searchParams.keyWord && !this.loading && this.searchList.length === 0;
    }
  },
  watch: {
    /**
     * 监听搜索列表是否展示，设置底层容器是否可以滚动
     */
    showSearchList: function (val) {
      if (val) {
        //展示则不可滚动
        document.body.style.overflow = 'hidden';
      } else {
        //隐藏则可滚动
        document.body.style.overflow = 'auto';
      }
    }
  },
  components: {
    'van-field': Field,
    'van-list': List,
    hHead,
    [Dialog.Component.name]: Dialog.Component
  },
  methods: {
    historySearch(keyWord) {
      this.searchParams = {
        keyWord,
        pageSize: 30,
        currentPage: 1
      };
      this.search();
    },
    saveSearchTerm(item) {
      this.searchHistory.push(item);
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    },
    clearSearchHistory() {
      Dialog.confirm({
        // title: 'Are you sure to delete all \n history records?',
        confirmButtonColor: '#FF9600',
        message: this.$t('PCSearch.index.dialogText'),
        confirmButtonText: this.$t('PCSearch.index.confirm'),
        cancelButtonText: this.$t('PCSearch.index.cancle')
      })
        .then(() => {
          this.searchHistory = [];
          localStorage.removeItem('searchHistory');
        })
        .catch(() => {
          // on cancel
        });
    },
    /**
     * 清空搜索框
     */
    clear() {
      this.searchParams.keyWord = '';
    },
    /**
     * 搜索机型
     */
    search() {
      this.loading = true;
      let { keyWord, currentPage, pageSize } = this.searchParams;
      let data = {
        pageIndex: currentPage,
        pageSize: pageSize,
        channelId: 100000,
        keyword: keyWord
      };
      searchPhoneModel(data).then(res => {
        if (res.code === '0000') {
          this.loading = false;
          this.searchList = this.searchList.concat(res.data.list);
          this.searchLoading = false;
          if (res.data.nextPage === 0) {
            this.searchFinished = true;
          }
        }
      });
    },
    /**
     * 监听搜索词的变化
     */
    keywordChange(data) {
      let value = data.target.value;
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.searchList = [];
      this.searchFinished = false;
      this.searchLoading = false;
      this.loading = true;
      this.searchParams.currentPage = 1;
      if (value) {
        this.timer = setTimeout(() => {
          this.search();
        }, 500);
      }
    },
    /**
     * 搜索列表上拉加载
     */
    onLoadSearch() {
      if (!this.searchFinished) {
        this.searchLoading = true;
        this.searchParams.currentPage++;
        this.search();
      }
    },

    /**
     * 跳转至设备属性页面
     * @param id
     */
    goPage(item) {
      // let choosePhoneModel = Object.assign({}, this.$data);
      // localStorage.setItem('choose-phone-model', JSON.stringify(choosePhoneModel));
      this.saveSearchTerm(item);
      const qrcode = this.$route.query.qrCode
      this.$router.push({
        name: 'Property',
        query: {
          id: item.productId,
          qrcode
        }
      });
      //清空搜索词，使返回时能不显示搜索结果弹窗
      this.searchParams.keyWord = '';
    },

    // 跳转至添加新机型页面
    goAddModel() {
      this.$router.push({
        name: 'newModel'
      });
      this.clear();
    },
    goto() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
// @import "../../../styles/reset.scss";
.pc_search-wrapper {
  background-color: #fff;
  height: 100%;
  position: absolute;
  width: 100%;

  .back {
    width: 24px;
    height: 24px;
    float: left;
    // position: absolute;
    // top: 20px;
    // left: 24px;
    margin-left: 12px;
    margin-top: 5px;
    img {
      width: 100%;
    }
  }
  .search-history {
    margin-top: 50px;
    // border-radius: 24px 24px 0 0;
    .search-history-title {
      display: flex;
      justify-content: space-between;
      padding: 16px 16px;
      font-size: 16px;
      font-weight: bold;
      .delete-icon {
        width: 18px;
        height: 18px;
      }
    }
    .search-history-list {
      display: block;
      // min-height: 200px;
      span {
        padding: 0px 12px;
        height: 32px;
        display: inline-block;
        line-height: 32px;
        border-radius: 16px;
        background: #f7f7f7;
        color: var(--text-2, #5d5f65);
        font-family: 'Helvetica Neue';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        margin-left: 12px;
        margin-bottom: 12px;
      }
    }
  }
  .search-input-wrapper.pxstrict {
    width: 100%;
    height: 50px;
    position: fixed;
    top: 0;
    left: 0;
    right: 12px;
    // transform: translate(50px, 0);
    z-index: 1000;
    background: #f7f7f7;
    padding-top: 9px;
    box-sizing: border-box;
    .input-wrapper {
      height: 32px;
      // display: flex;
      // align-items: center;
      border-radius: 16px;
      font-size: 14px;
      // border: 1.5px solid #FF8A14;
      overflow: hidden;
      position: relative;
      margin-left: 44px;
      .i-search {
        position: absolute;
        top: 8px;
        left: 16px;
        background: url('../../assets/image/search/search.png');
        // @include bg("../../../assets/search");
        width: 16px;
        height: 16px;
        vertical-align: middle;

        background-size: cover;
        background-position: center; /* 图片居中 */
        background-repeat: no-repeat; /* 避免图片重复 */

        // margin: 0 8px 0 12px;
      }
      .search-input {
        // flex: 1;
        //width: 100%;
        // min-width: 300px;
        width: calc(100% - 12px);
        height: 32px;
        line-height: 32px;
        padding-right: 23px;
        padding-left: 36px;
        box-sizing: border-box;
        border: 1px solid #fff;
        border-radius: 16px;
        // background: #f2f2f2;

        .van-field__body {
          height: 100%;
        }
        margin-right: 12px;
      }
      .search-input::placeholder {
        color: #ccc;
      }
      .search-input:focus {
        outline: none;
        border: 1px solid #ff8a14;
        caret-color: #ff8a14;
      }
      input::placeholder {
        font-size: 12px;
      }
      // input {
      //   border: none;
      //   background: #fff;
      //   caret-color: #FF8A14;
      // }
      .i-clear {
        position: absolute;
        top: 8px;
        right: 12px;
        background: url('../../assets/image/search/close.png');
        // @include bg("../../../assets/search_clear");
        width: 14px;
        height: 14px;
        vertical-align: middle;
        // margin-right: 12px;
        background-size: cover;
        //background-position: center; /* 图片居中 */
        //background-repeat: no-repeat; /* 避免图片重复 */
      }
    }
  }
  .van-list-wrapper.pxstrict {
    top: 49px;
  }
  .van-list-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 100;
    overflow: auto;
    padding: 0 13px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    .search-item {
      height: 40px;
      line-height: 40px;
      padding: 0 24px 0 0;
      box-sizing: border-box;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #333;
      .name {
        // @include singleEllipsis(100%);
      }
      .name-has-alias {
        // @include singleEllipsis(225);
      }
      .alias {
        // @include singleEllipsis(100);
        text-align: right;
        color: #808080;
        font-size: 14px;
      }
    }
  }
  .search-list-blank.pxstrict {
    position: fixed;
    left: 0;
    right: 0;
    top: 49px;
    bottom: 0;
    overflow: hidden;
    padding: 0 18px;
    font-size: 14px;
    line-height: 22px;
    background: #fff;
    z-index: 100;
  }

  .text-no {
    display: flex;
    justify-content: center;
    color: #ff8a14;
    font-size: 14px;
    flex-direction: column;
    align-items: center;
    img {
      width: 320px;
      height: 320px;
      margin-top: 290px;
    }
    span {
      color: var(--text-1, #252629);
      font-family: 'Helvetica Neue';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: block;
    }
  }
}
</style>
